export const navigationLinks = {
  solutions: [
    { label: "Photovoltaik", href: "#" },
    { label: "Batteriespeicher", href: "#" },
    { label: "Wärmepumpen", href: "#" },
    { label: "Wallboxen", href: "#" },
  ],
  properties: [
    { label: "Einfamilienhaus", href: "#" },
    { label: "Gewerbe", href: "#" },
    { label: "Mehrfamilienhaus", href: "#" },
    { label: "Landwirtschaft", href: "#" },
    { label: "Stromspeicher", href: "#" },
  ],
  resources: [
    { label: "Förderprogramme", href: "#" },
    { label: "Photovoltaik-Leitfaden", href: "#" },
    { label: "Kundenberichte", href: "#" },
    { label: "Zweering News", href: "#" },
    { label: "Solarrechner", href: "#" },
  ],
  evDrivers: [
    { label: "Ladestation aktivieren", href: "#" },
    { label: "Kundenportal", href: "#" },
    { label: "Support", href: "#" },
  ],
};

export const companyLinks = [
  { label: "Unternehmen", href: "#" },
  { label: "Blog", href: "#" },
  { label: "Karriere", href: "#" },
  { label: "Partner werden", href: "#" },
  { label: "Home-Ladesystem", href: "#" },
  { label: "Kontakt", href: "#" },
  { label: "Login", href: "#" },
];

export const footerProperties = [
  { label: "Einfamilienhaus", href: "#" },
  { label: "Gewerbe", href: "#" },
  { label: "Mehrfamilienhaus", href: "#" },
  { label: "Landwirtschaft", href: "#" },
];

export const footerSolutions = [
  { label: "Unsere Technologie", href: "#" },
  { label: "Service", href: "#" },
  { label: "Sicherheitslösungen", href: "#" },
];

export const footerResources = [
  { label: "Förderprogramme", href: "#" },
  { label: "Photovoltaik-Leitfaden", href: "#" },
  { label: "Kundenberichte", href: "#" },
  { label: "Zweering News", href: "#" },
];

export const footerDrivers = [
  { label: "Ladestation aktivieren", href: "#" },
  { label: "Kundenportal", href: "#" },
  { label: "Support", href: "#" },
];

export const footerCompany = [
  { label: "Unternehmen", href: "#" },
  { label: "Karriere", href: "#" },
  { label: "Partner werden", href: "#" },
  { label: "Home-Ladesystem", href: "#" },
  { label: "Kontakt", href: "#" },
  { label: "Login", href: "#" },
];

export const partnerLogos = [
  { name: "SMA", src: "" },
  { name: "Fronius", src: "" },
  { name: "BYD", src: "" },
  { name: "Mennekes", src: "" },
];

export const accreditations: { name: string; src: string }[] = [];

import mehrfamilienhausImg from "@/assets/mehrfamilienhaus-pv-dachanlage.webp";
import einfamilienhausImg from "@/assets/einfamilienhaus-pv-satteldach.webp";
import gewerbeImg from "@/assets/gewerbe-pv-flachdach-halle.webp";

export const propertyCards = [
  {
    title: "Einfamilienhaus",
    description: "Maßgeschneiderte Photovoltaik-Lösungen für Ihr Eigenheim – mit maximaler Eigenverbrauchsoptimierung.",
    image: einfamilienhausImg,
    alt: "Modernes Einfamilienhaus aus Backstein mit schwarzer Photovoltaik-Anlage und Dachfenster auf dem Satteldach, Wallbox am Eingang im Abendlicht",
    href: "/einfamilienhaus",
  },
  {
    title: "Mehrfamilienhaus",
    description: "Gemeinschaftliche Solaranlagen für Wohnanlagen – fair verteilt und einfach verwaltet.",
    image: mehrfamilienhausImg,
    alt: "Modernes Mehrfamilienhaus mit Photovoltaik-Anlage auf dem Flachdach und Balkonen in der Abendsonne",
    href: "/mehrfamilienhaus",
  },
  {
    title: "Gewerbe",
    description: "Kosteneffiziente Energielösungen für Unternehmen – reduzieren Sie Ihre Stromkosten und sichern Sie Ihre Unabhängigkeit.",
    image: gewerbeImg,
    alt: "Moderne Gewerbehalle mit großflächiger Photovoltaik-Aufdachanlage auf dem Flachdach aus der Vogelperspektive",
    href: "/gewerbe",
  },
];


export const intelligentFeatures = [
  "Photovoltaik und Speicher für maximale Eigenstrom-Nutzung",
  "Wärmepumpe und Smart Home für effizientes Heizen",
  "Ersatzstrom für Sicherheit bei Netzausfall — das ganze Haus läuft weiter",
];

import zertifizierteQualitaetImg from "@/assets/zertifizierte-qualitaet-meisterbrief.webp";
import komplettloesungImg from "@/assets/komplettloesung-wechselrichter-installation.webp";
import foerdermittelImg from "@/assets/foerdermittel-kfw-antrag.webp";

export const journeyCards = [
  {
    title: "Komplettlösung aus einer Hand",
    description: "Von der Planung über die Installation bis zur Wartung – Zweering Elektrotechnik kümmert sich um alles, während Sie sich auf Ihr Kerngeschäft konzentrieren.",
    image: komplettloesungImg,
    alt: "Elektromeister von Zweering verkabelt einen Wechselrichter einer Photovoltaik-Anlage mit isoliertem Schraubendreher",
    href: "/smart-home",
  },
  {
    title: "Fördermittel-Optimierung",
    description: "Nutzen Sie KfW, BAFA und weitere Programme – wir beantragen alle Förderungen für Sie und maximieren Ihre Einsparungen.",
    image: foerdermittelImg,
    alt: "KfW-Förderantrag für Photovoltaik mit Taschenrechner, Füller und Energie-Monitoring-App auf dem Smartphone",
    href: "/einfamilienhaus",
  },
  {
    title: "Zertifizierte Qualität",
    description: "Bauen Sie auf Vertrauen – unsere Meisterqualifikation und Zertifizierungen gewährleisten, dass Sie jederzeit flexibel wechseln oder erweitern können.",
    image: zertifizierteQualitaetImg,
    alt: "Gerahmter Meisterbrief des Elektrohandwerks an einer Backsteinwand in der Zweering-Werkstatt",
    href: "/ueber-uns",
  },
];


export const clientProfile = {
  hasRealQuote: true,
  tag: "Kundenstimme",
  title: "Endlich ein Ansprechpartner, der wirklich alles aus einer Hand macht",
  description: "Von der ersten Beratung bis zur Inbetriebnahme unserer 12-kWp-Anlage mit Speicher und Wallbox — das Team von Zweering war immer erreichbar, hat sauber gearbeitet und sämtliche Förderanträge übernommen. Kein Vergleich zu den üblichen 'wir machen nur das Dach'-Anbietern. Besonders geschätzt haben wir, dass nach der Montage alles verständlich erklärt wurde und wir jetzt genau wissen, wie wir den Eigenverbrauch optimieren. Absolut empfehlenswert. — Familie Mertens, Emmerich am Rhein",
  image: "https://readdy.ai/api/search-image?query=Happy%20German%20family%20standing%20in%20front%20of%20their%20modern%20house%20with%20visible%20solar%20panels%20on%20roof%2C%20bright%20sunny%20day%2C%20warm%20smiles%2C%20professional%20lifestyle%20photography&width=600&height=750&seq=client-profile&orientation=portrait",
};

export const faqItems = [
  {
    question: "Was kostet eine Photovoltaik-Anlage?",
    answer: "Die Kosten einer Photovoltaik-Anlage hängen von der Anlagengröße, den verwendeten Komponenten und den baulichen Gegebenheiten ab. Eine typische Anlage für ein Einfamilienhaus mit 8–10 kWp liegt zwischen 12.000 und 18.000 Euro. Im persönlichen Beratungsgespräch erstellen wir ein maßgeschneidertes Angebot für Ihre Immobilie.",
  },
  {
    question: "Wie lange dauert die Installation?",
    answer: "Die reine Installation auf dem Dach dauert in der Regel 1–2 Tage. Hinzu kommen die Elektroinstallation und der Netzanschluss. Vom Auftrag bis zur fertigen Anlage rechnen Sie mit etwa 2–4 Wochen. Die genaue Dauer besprechen wir in der Vor-Ort-Begehung.",
  },
  {
    question: "Übernehmen Sie auch die Förderung und Anmeldung?",
    answer: "Ja, wir kümmern uns um die vollständige Abwicklung: von der Anmeldung beim Netzbetreiber über die Beantragung von Fördermitteln bis hin zur Registrierung im Marktstammdatenregister. Sie erhalten Ihre schlüsselfertige Anlage aus einer Hand.",
  },
  {
    question: "Bieten Sie Wartung und Notdienst?",
    answer: "Selbstverständlich. Wir bieten regelmäßige Wartungsintervalle für Ihre Anlage an und stehen Ihnen auch im Störfall zur Verfügung. Unser Serviceteam ist schnell vor Ort — in der Regel innerhalb von 24 Stunden, bei dringenden Notfällen auch schneller.",
  },
  {
    question: "In welchem Umkreis arbeiten Sie?",
    answer: "Unser Haupt-Einsatzgebiet liegt im Kreis Kleve mit Schwerpunkt Emmerich am Rhein, Rees, Kalkar und Kleve. Darüber hinaus sind wir im gesamten Niederrhein-Gebiet sowie in angrenzenden niederländischen Grenzregionen für Sie tätig. Sprechen Sie uns einfach an.",
  },
];

export const newsItems = [
  {
    category: "Projekt",
    date: "12.06.2026",
    title: "Neue PV-Großanlage in Emmerich erfolgreich in Betrieb genommen",
    image: "https://readdy.ai/api/search-image?query=Large%20rooftop%20solar%20panel%20installation%20on%20modern%20industrial%20building%20in%20Germany%2C%20bright%20sunny%20day%2C%20professional%20photovoltaic%20system%20rows%2C%20clean%20green%20energy%20photography%20with%20blue%20sky%20and%20white%20clouds&width=800&height=520&seq=news-pv-emmerich&orientation=landscape",
  },
  {
    category: "News",
    date: "05.06.2026",
    title: "Zweering Elektrotechnik erweitert Team um zwei Monteure",
    image: "https://readdy.ai/api/search-image?query=Two%20professional%20electricians%20in%20work%20uniform%20standing%20next%20to%20solar%20installation%20truck%2C%20smiling%20team%20photo%2C%20German%20industrial%20background%2C%20warm%20natural%20lighting%2C%20professional%20corporate%20photography&width=800&height=520&seq=news-team&orientation=landscape",
  },
  {
    category: "News",
    date: "28.05.2026",
    title: "Förderung 2026: Was sich für Eigenheimbesitzer ändert",
    image: "https://readdy.ai/api/search-image?query=Modern%20German%20family%20home%20with%20solar%20panels%20and%20EV%20charging%20station%20in%20driveway%2C%20golden%20hour%20lighting%2C%20sustainable%20living%20concept%2C%20warm%20editorial%20photography%20with%20green%20lawn%20and%20blue%20sky&width=800&height=520&seq=news-funding&orientation=landscape",
  },
  {
    category: "News",
    date: "15.05.2026",
    title: "Wallbox-Installationen steigen im Kreis Kleve um 40%",
    image: "https://readdy.ai/api/search-image?query=Modern%20electric%20vehicle%20charging%20at%20home%20wallbox%20station%2C%20sleek%20white%20EV%20car%20in%20residential%20driveway%2C%20German%20suburban%20house%20with%20solar%20panels%2C%20professional%20automotive%20photography%20with%20soft%20natural%20lighting&width=800&height=520&seq=news-wallbox&orientation=landscape",
  },
];